// extracted by mini-css-extract-plugin
export default {"disclaimer-container":"style_disclaimer-container__lb8jh"};